import { ICanScroll } from './types'

function calculateCenter(el: HTMLElement, offset = 0) {
  const { width, left } = el.getBoundingClientRect()
  return left + width / 2 - offset
}

function calculateLeft(el: HTMLElement, offset = 0) {
  const { left } = el.getBoundingClientRect()
  return left - offset
}

function calculateScrollOffset(
  target: HTMLElement,
  container: HTMLElement,
  toLeft: boolean = false,
  offset: number = 0
): number {
  if (toLeft) {
    const targetCenter = calculateLeft(target, offset)
    const containerCenter = calculateLeft(container, 0)
    return targetCenter - containerCenter
  }
  const targetCenter = calculateCenter(target, offset)
  const containerCenter = calculateCenter(container, 0)
  return targetCenter - containerCenter
}

function getCanScroll(
  scrollLeft: number,
  width: number,
  scrollWidth: number,
  distance: number
): ICanScroll {
  return {
    canScrollRight: scrollLeft + distance > 0,
    canScrollLeft: scrollLeft + width + distance < scrollWidth
  }
}

export { calculateScrollOffset, getCanScroll }
